// extracted by mini-css-extract-plugin
export default {"wrapper":"dkim_wrapper__9sLXq","title":"dkim_title__0SXXF","actions":"dkim_actions__D2M+0","trashIcon":"dkim_trashIcon__toG8R"};